// @ts-nocheck
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { ITicketingType } from '../../models'
import { LiteralsService, TownService } from '../../services'
import literalsService from '../../services/literals-service'
import {
  fetchAreasSuccessfulAction,
  fetchClientInfosSuccessfulAction,
  setIsFetchingAreasAction,
  setIsFetchingClientInfoAction,
  setNotificationAction,
  setShowPaymentMethodAction
} from '../actions'
import { ConfigurationTypeKeys } from '../types'
import { selectBookingTownId, selectUserTown } from './helpers'

// Worker Saga
function* fetchAreasAsync() : any {
  try {
    yield put(setIsFetchingAreasAction())
    const areas = yield call(TownService.getTowns)
    yield put(fetchAreasSuccessfulAction(areas))
  } catch (error) {
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.get('serverError', true)
      })
    )
  }
}

function* fetchClientInfoAsync(): any {
  try {
    yield put(setIsFetchingClientInfoAction())
    const townId = yield selectBookingTownId()
    const clientInfo = yield call(TownService.getClientInfo, townId)
    yield put(fetchClientInfosSuccessfulAction(clientInfo))
  } catch (error) {
    yield put(
        setNotificationAction({
          isError: true,
          label: literalsService.get('serverError', true)
        })
    )
  }
}

function* checkIfShowPaymentMethodAsync(): any {
  try {
    const town = yield selectUserTown()
    const services = yield call(TownService.getServicesTicketingType, town.id)

    let hasPayment = false;
    if (services.some((service: any) => service.ticketingType === ITicketingType.Online || service.ticketingType === ITicketingType.Hybrid || service.ticketingType === ITicketingType.Periodically)) hasPayment = true

    yield put(setShowPaymentMethodAction(hasPayment))
  } catch (error) {
    yield put(
        setNotificationAction({
          isError: true,
          label: literalsService.get('serverError', true)
        })
    )
  }
}

// Watcher Saga:
function* watchFetchAreasAsync() {
  yield takeLatest(ConfigurationTypeKeys.FETCH_AREAS, fetchAreasAsync)
}

function* watchFetchClientInfoAsync() {
  yield takeLatest(ConfigurationTypeKeys.FETCH_CLIENT_INFO, fetchClientInfoAsync)
}

function* watchCheckIfShowPaymentMethodAsync() {
  yield takeLatest(ConfigurationTypeKeys.CHECK_IF_SHOW_PAYMENT_METHOD, checkIfShowPaymentMethodAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    watchFetchAreasAsync(),
    watchFetchClientInfoAsync(),
    watchCheckIfShowPaymentMethodAsync()
  ])
}
